import axios from "axios";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import {
  BusStationsApi,
  castErrorResult,
  createCatchErrorResult,
  createSuccessResult,
  IRydeProcess,
  Log,
  SimpleResult,
  simpleResultInvalidApiResponse,
} from "@ryde/shared";

export const useBusStationActions = () => {
  const { t } = useTranslation();

  const importStationsFromBusStations = useEvent(
    async ({
      busStationsIds,
      isCreateMissingAreas,
    }: {
      busStationsIds: number[];
      isCreateMissingAreas?: boolean;
    }): Promise<SimpleResult<IRydeProcess>> => {
      try {
        const result = await BusStationsApi.importStationsFromBusStations({
          busStationsIds,
          isCreateMissingAreas,
        });

        if (!result) {
          return simpleResultInvalidApiResponse(t);
        }

        if (!result?.success || !result.data) {
          return castErrorResult(result);
        }

        return createSuccessResult(result.data);
      } catch (error) {
        if (axios.isCancel(error)) {
          Log.debug("Axios, request canceled", error);
          return createCatchErrorResult(error, t);
        }

        return createCatchErrorResult(error, t);
      }
    },
  );

  return {
    importStationsFromBusStations,
  };
};
